import React from "react";
import { withStyles } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import orderBy from "lodash/orderBy";
import moment from "moment";

const styles = theme => ({
  tooltips: {
    position: "relative",
    display: "inline"
  },
  tooltips_span: {
    position: "absolute",
    color: "#262626",
    background: "#FFFFFF",
    border: ".5px solid #BFBFBF",
    fontSize: "12px",
    fontWeight: 600,
    // height: "30px",
    // lineHeight: "30px",
    textTransform: "uppercase",
    textAlign: "center",
    visibility: "visible",
    padding: "4px 4px",
    borderRadius: "2px",
    top: "-35px",
    right: "-40px",
    "&:before": {
      content: "''",
      position: "absolute",
      top: "100%",
      left: "50%",
      marginLeft: "-12px",
      width: "0",
      height: "0"
      // borderTop: "4px solid #BFBFBF",
      // borderRight: "4px solid transparent",
      // borderLeft: "4px solid transparent",
    },
    "&:after": {
      content: "''",
      position: "absolute",
      top: "100%",
      left: "50%",
      marginLeft: "-4px",
      width: "0",
      height: "0",
      borderTop: "8px solid #FFFFFF",
      borderRight: "8px solid transparent",
      borderLeft: "8px solid transparent"
    }
  },
  hover_tooltips_span: {
    visibility: "visible",
    opacity: "0.7",
    bottom: "30px",
    left: "50%",
    marginLeft: "-76px"
  },
  niftyHoverBackground: {
    backgroundColor: theme.palette.primary.dark,
    color: "white",
    border: "none",
    zIndex: 100,
    "&:after": {
      content: "''",
      position: "absolute",
      top: "100%",
      left: "50%",
      marginLeft: "-4px",
      width: "0",
      height: "0",
      borderTop: "8px solid #7E1541",
      borderRight: "8px solid transparent",
      borderLeft: "8px solid transparent"
    }
  },
  markerParent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
});

class MapMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
  }

  handleMouseOver = () => {
    this.setState({
      isHovered: true
    });
  };

  handleMouseLeave = () => {
    this.setState({
      isHovered: false
    });
  };

  handleMarkerClick = mlsNumber => {
    this.props.handleMarkerClick(mlsNumber);
    // (e) => {
    //     this.props.handleMarkerClick(mlsNumber, { lat, lng });
  };

  handleCloseClick = () => {
    this.props.setActive(null);
  };

  render() {
    const { selectedListingMls, listing, active } = this.props;
    const { isHovered } = this.state;
    const showMarkerListing =
      isHovered || listing.mlsNumber === selectedListingMls || active;

    const renderMapMarkerInfo = () => {
      const getNextOpenHouse = listing => {
        const nextOpenHouse = orderBy(listing.openHouses, ["date", "asc"])[0];
        return (
          moment(nextOpenHouse.date).format("ddd") +
          " " +
          nextOpenHouse.openHouseTimeFrame
        );
      };

      return (
        <div
          className=""
          style={{
            position: "absolute",
            top: "0",
            left: "-185px",
            width: "367px"
          }}
        >
          <div className="" style={{ right: "0px", bottom: "41px" }}>
            <div
              className=""
              style={{
                paddingRight: "0px",
                paddingBottom: "0px",
                maxWidth: "654px",
                maxHeight: "427px"
              }}
            >
              <div
                className=""
                style={{
                  maxWidth: "636px",
                  maxHeight: "409px"
                }}
              >
                <div id="infoWindow">
                  <div
                    className="cardone"
                    style={{ width: "367.4px", height: "270px" }}
                  >
                    <button
                      className="close"
                      aria-label="Close"
                      onClick={this.handleCloseClick}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="card img-loaded">
                      <a
                        className="card-link"
                        href={`/listings/detail/${listing.mlsNumber}`}
                        rel="noopener noreferrer"
                        onMouseEnter={this.handleMouseOver}
                        onMouseLeave={this.handleMouseLeave}
                      >
                        <div className="card-photo">
                          <img
                            className="lazy"
                            alt=""
                            src={listing.primaryPhotoUrl}
                          />
                        </div>
                        <div className="info">
                          <div className="price">
                            <span className="price-title">
                              {listing.price && (
                                <NumberFormat
                                  value={listing.price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                              )}
                            </span>
                          </div>
                          <div className="top-base-info">
                            <span>{listing.totalBedRooms} Beds</span>
                            <span>{listing.totalBaths} Baths</span>
                          </div>
                          <div className="flex-info">
                            <div className="flex-info-left">
                              <div className="addresslink desc-comma">
                                <span>{listing.addressStreet} </span>
                                <span className="address-city">
                                  {listing.addressCity}
                                </span>
                                <span> {listing.addressState}</span>
                                <span className="nocomma">
                                  {" "}
                                  {listing.addressZip}
                                </span>
                              </div>
                              <div className="mlsinfo" />
                            </div>
                          </div>
                        </div>
                        {listing.isHobson && (
                          <span className="hobson-card-badge">
                            <img
                              src="/HobsonTheme.OrchardCore/img/hobson_hires_150.png"
                              alt="hobsonlogo_thumbnail"
                              width="100px"
                            />
                          </span>
                        )}
                      </a>
                      <div className="labels">
                        {listing.ribbonText && listing.RibbonText !== "" && (
                          <span className="label bg-info">{listing.ribbonText}</span>
                        )}
                        {(listing.status === 'CNTG' || listing.status === 'PEND') && (
                          <span className="label bg-warning">
                            {listing.status}
                          </span>
                        )}
                      </div>
                      {listing.openHouses && listing.openHouses.length > 0 && (
                        <div
                          className="labels openhouse-overlay"
                          style={{
                            right: "10%",
                            left: "unset",
                            width: "unset"
                          }}
                        >
                          <span className="label bg-secondary">
                            {getNextOpenHouse(listing)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const SI_SYMBOL = ["", "K", "M", "G", "T", "P", "E"];

    const abbreviateNumber = number => {
      // what tier? (determines SI symbol)
      const tier = (Math.log10(number) / 3) | 0;

      // if zero, we don't need a suffix
      if (tier == 0) return number;

      // get suffix and determine scale
      const suffix = SI_SYMBOL[tier];
      const scale = Math.pow(10, tier * 3);

      // scale the number
      const scaled = number / scale;

      // format number and add suffix
      return "$" + scaled + suffix;
    };

    return (
      <>
        {showMarkerListing && renderMapMarkerInfo()}
        <div
          key={listing.mlsNumber}
          role="button"
          tabIndex="0"
          className={`listings-search-map-label ${showMarkerListing &&
            "isHovered"}`}
          style={{ zIndex: this.isHovered ? 1000 : 0 }}
          onClick={() => this.handleMarkerClick(listing.mlsNumber)}
          onMouseEnter={this.handleMouseOver}
          onMouseLeave={this.handleMouseLeave}
        >
          <div className="listings-search-map-label-inner">
            <div className="listings-search-map-tooltip" />
            <div className="listings-search-map-label-inner2">
              <h6 className="listings-search-map-label-price">
                {listing.shortPrice}
              </h6>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(MapMarker);
